export const SmallSpinner = () => {
  return (
    <span className="box-border inline-block h-5 w-5 animate-[spin_0.5s_linear_infinite] rounded-full border-2 border-gray-500 border-b-transparent" />
  )
}
